import { OperationCode } from "../enum/operation-code";
import { ProductFull } from "../product/product-full";

export class ContractManual {

    contractId: number | null = null;
    country: string = '';
    operation = OperationCode.CAR;
    status: number = 0;
    user: string = '';
    saleDate = new Date();
    startDate: Date | null = null;
    endDate: Date | null = null;
    saleType: number = 0;
    tmaCode: string = '';
    vehicleLineCode: string = '';
    modelYear: number = 0;

    vin: string = '';
    cvvgDate: Date | null = null;
    product: ProductFull | null = null;
    oldContractId: string = '';
    isGlobalContract: boolean = false;
    message: string = '';
    hasError = false;

    constructor() {
    }
}